import StateView from "@components/StateView/StateView";
import THelper from "@helper/THelper";
import RoomModel from "@model/RoomModel";
import CartModel from "@model/cart/CartModel";
import ExtraModel from "@model/cart/ExtraModel";
import OfferQuickModel from "@model/cart/OfferQuickModel";
import PeopleModel from "@model/cart/PeopleModel";
import { message } from "antd";
import { makeAutoObservable, observable, set } from "mobx";
import { Routes } from "../../config/routes";
import { CartService } from "../../queries/cart/cart.service";

export default class checkoutController {
  step = 1;
  rooms = observable([]);
  extras = observable([]);
  custom_field = observable([]);
  countries = observable([]);

  cartId = "";
  cart = new CartModel();
  peopleRoom = 0;
  offer = new OfferQuickModel();
  stateView = StateView.State.loading;
  stateViewPayment = StateView.State.loading;
  stateViewPay = StateView.State.content;

  paymentMethod = "paypal";
  rule1 = false;
  rule2 = false;
  loading = false;
  loadingCoupon = false;
  loadingSide = false;
  loadingCheckout = false;
  openTerms = false;

  paymentKey = "";
  paymentType = "full";
  paymentId = "";
  paymentReference = "";
  router = "";
  isImmediate = 0;
  formClear = false;
  submitted = false;
  voucherError = "";
  showVoucherError = false;
  NewTotalPrice = 0;
  NewVoucherPrice = null;
  isCoupanValid = false;
  voucher = null;
  bookingId = "";
  isPopular = false;
  cardDetails = {};
  successPaymentRedirectURL = "/user/booking/confirmed?code=";
  cart_currency = "EUR";

  // MANGOPAY DATA:
  cardData = null;
  isSubmitBtnDisabled = true;

  constructor() {
    makeAutoObservable(this);
  }

  reset = () => {
    this.peopleRoom = 0;
  };

  changeTerms = (status) => {
    this.openTerms = status;
  };
  setRouter(router) {
    this.router = router;
  }

  paymentChange(type, redirect, data) {
    switch (type) {
      case "paypal":
        this.getPaypalUrl(
          { method: "paypal", paymentType: this.paymentType },
          redirect
        );
        break;
      case "cc":
        this.getSecretPay({ method: "cc", paymentType: this.paymentType });
        break;
      case "stripe":
        this.getSecretPayStripe({
          method: "stripe",
          paymentType: this.paymentType,
        });
        break;
      case "sofort":
        this.getSecretSofort({
          method: "sofort",
          paymentType: this.paymentType,
        });
        break;
      case "klarna":
        this.getSecretKlarna({ ...data, paymentType: this.paymentType });
        break;
      default:
        this.getSecretPayStripe({
          method: type,
          paymentType: this.paymentType,
        });
    }
  }

  paymentChangeLive = (type) => {
    this.getSecretPay({ method: type, paymentType: this.paymentType });
  };

  silentDataSide = () => {
    this.loadingSide = true;
    CartService.getCart({ code: this.cartId })
      .then((res) => {
        this.NewTotalPrice = res?.total_price;
        this.NewVoucherPrice = res?.voucher_price;

        set(this.cart, res.details);
        const mo = new OfferQuickModel();
        set(mo, res.details.offer);
        this.offer = mo;
        set(this.cart, { offer: mo });
        set(this.cart, res.prices);
        set(this.cart, { total_price: res.total_price });
        set(this.cart, { basePrice: res.base_price });
        set(this.cart, { voucher: res.voucher });

        set(this.cart, { rooms: res.rooms, extras: res.extras });
        for (let i = 0; i < this.cart.people; i++) {
          const m = new PeopleModel();
          this.cart.peopleData.push(m);
        }
        this.loadingSide = false;
      })
      .catch((e) => {
        this.loadingSide = false;
      });
  };

  // /booking/card/details?code=
  getData = (data = {}, typeGet = "") => {
    this.stateView = StateView.State.loading;
    this.cartId = data.code;
    const res = CartService.getData(data)
      .then((res) => {
        this.isPopular = res?.isPopular;
        this.NewTotalPrice = res?.total_price;
        this.NewVoucherPrice = res?.voucher_price;
        this.isImmediate = res?.details?.offer?.immediate;
        this.cart_currency = res?.price_currency;

        set(this.cart, res?.details);
        set(this.cart, res?.prices);
        set(this.cart, { basePrice: res?.base_price });
        set(this.cart, { total_price: res?.total_price });
        set(this.cart, { extras_count: res?.extras_count });
        set(this.cart, { price_currency: res?.price_currency });

        const mo = new OfferQuickModel();
        set(mo, res?.details.offer);
        this.offer = mo;
        set(this.cart, { offer: mo });
        set(this.cart, { rooms: res?.rooms, extras: res?.extras });
        if (res?.voucher != null) {
          set(this.cart, { voucher: res?.voucher });
        }

        for (let i = 0; i < this.cart?.people; i++) {
          const m = new PeopleModel();
          this.cart?.peopleData?.push(m);
        }

        switch (typeGet) {
          case "rooms":
            this.getRooms(data);
            break;
          case "extras":
            this.getExtras(data);
            break;
          case "info":
            this.getInfo(data);
            break;
          default:
            this.stateView = StateView.State.content;
        }
      })
      .catch((error) => {
        message.error("Card not found!");
        this.stateView = StateView.State.error;
      });
  };

  cartData = (data = {}, typeGet = "") => {
    this.stateView = StateView.State.loading;
    this.cartId = data.code;
    const res = CartService.cartData(data)
      .then((res) => {
        this.NewTotalPrice = res?.total_price;
        this.NewVoucherPrice = res?.voucher_price;
        this.bookingId = res?.details?.id;
        this.cardDetails = res?.details;
        this.cart_currency = res?.price_currency;

        set(this.cart, res.details);
        set(this.cart, res.prices);
        set(this.cart, { base_price: res.base_price });
        set(this.cart, { basePrice: res.base_price });
        set(this.cart, { total_price: res.total_price });
        const mo = new OfferQuickModel();
        set(mo, res.details.offer);
        this.offer = mo;
        set(this.cart, { offer: mo });
        set(this.cart, { rooms: res.rooms, extras: res.extras });
        if (res.voucher != null) {
          set(this.cart, { voucher: res.voucher });
        }

        for (let i = 0; i < this.cart.people; i++) {
          const m = new PeopleModel();
          this.cart.peopleData.push(m);
        }

        this.stateView = StateView.State.content;
      })
      .catch((e) => {
        this.stateView = StateView.State.error;
      });
  };

  getDataRemaining = (id) => {
    this.stateView = StateView.State.loading;
    this.cartId = id;
    const res = CartService.getDataRemaining({ code: id })
      .then((res) => {
        if (res?.httpStatus == 404) {
          return (this.stateView = StateView.State.error);
        }

        this.NewTotalPrice = res?.total_price;
        this.NewVoucherPrice = res?.voucher_price;
        this.bookingId = res?.details?.id;
        this.cardDetails = res?.details;
        this.cart_currency = res?.price_currency;

        set(this.cart, res.details);
        set(this.cart, res.prices);
        set(this.cart, { base_price: res.base_price });
        set(this.cart, { basePrice: res.base_price });
        set(this.cart, { total_price: res.total_price });
        const mo = new OfferQuickModel();
        set(mo, res.details.offer);
        this.offer = mo;
        set(this.cart, { offer: mo });
        set(this.cart, { rooms: res.rooms, extras: res.extras });
        if (res.voucher != null) {
          set(this.cart, { voucher: res.voucher });
        }

        for (let i = 0; i < this.cart.people; i++) {
          const m = new PeopleModel();
          this.cart.peopleData.push(m);
        }

        this.stateView = StateView.State.content;
      })
      .catch((e) => {
        this.stateView = StateView.State.error;
      });
  };

  getInstallment = (data = {}, typeGet = "") => {
    this.stateView = StateView.State.loading;
    this.cartId = data.code;
    const res = CartService.getInstallment(data)
      .then((res) => {
        set(this.cart, res.details);
        set(this.cart, res.prices);
        const mo = new OfferQuickModel();
        set(mo, res.details.offer);
        this.offer = mo;
        set(this.cart, { offer: mo });

        set(this.cart, { rooms: res.rooms, extras: res.extras });

        for (let i = 0; i < this.cart.people; i++) {
          const m = new PeopleModel();
          this.cart.peopleData.push(m);
        }

        this.stateView = StateView.State.content;
      })
      .catch((e) => {
        this.stateView = StateView.State.error;
      });
  };

  getRooms = (data = {}) => {
    this.rooms = [];
    this.stateView = StateView.State.loading;
    CartService.getRooms(data)
      .then((res) => {
        const rooms = [];

        if (res.items.length > 0) {
          try {
            res.items.map((data, index) => {
              const model = new RoomModel();
              set(model, data);
              rooms.push(model);
            });
          } catch (e) {
            console.log(e);
          }

          this.rooms = rooms;
        }

        this.stateView = StateView.State.content;
      })
      .catch((e) => {
        this.stateView = StateView.State.error;
      });
  };
  changeRoomQuantity = (quantity, roomIndex, index) => {
    this.rooms[index].rooms[roomIndex].quantity = quantity;
  };

  removeRoom = (roomIndex, index) => {
    this.rooms[index].cart[roomIndex].loading = true;
    const data = {
      id: this.rooms[index].cart[roomIndex].id,
      people_id: this.rooms[index].cart[roomIndex].people_id,
    };
    CartService.removeRoom(data, { code: this.cartId })
      .then((res) => {
        this.peopleRoom -= parseInt(
          this.rooms[index].cart[roomIndex].people *
            this.rooms[index].cart[roomIndex].quantity
        );
        this.rooms[index].cart.splice(roomIndex, 1);
        this.silentDataSide();
      })
      .catch((e) => {
        this.rooms[index].cart[roomIndex].loading = false;
      });
  };

  addRoom = (baseData, roomIndex, index, i3) => {
    this.rooms[index].rooms[roomIndex].loading = true;
    this.rooms[index].loadingAad = true;
    const data = {
      people_id: this.rooms[index].rooms[roomIndex].peopleId,
      quantity: this.rooms[index].rooms[roomIndex].quantity,
    };
    CartService.addRoom(data, { code: this.cartId })
      .then((res) => {
        this.rooms[index].rooms[roomIndex].loading = false;
        this.rooms[index].rooms[roomIndex].quantity = 1;
        this.rooms[index].loadingAad = false;

        if (res.httpStatus == 200) {
          if (res.room != undefined) {
            this.rooms[index].cart.push(res.room);
            this.peopleRoom += parseInt(res.room.people * res.room.quantity);
          }
          this.silentDataSide();
        } else {
          this.rooms[index].loadingAad = false;

          message.error(THelper.t("checkout.error_cannot_add_room"));
        }
      })
      .catch((e) => {
        message.error(THelper.t("checkout.error_cannot_add_room"));
        this.rooms[index].loadingAad = false;
        this.rooms[index].rooms[roomIndex].loading = false;
      });
  };

  getExtras = (data = {}) => {
    this.stateView = StateView.State.loading;
    this.extras = [];
    const res = CartService.getExtras(data, { code: this.cartId })
      .then((res) => {
        const extras = [];
        if (res.length > 0) {
          res.map((data, index) => {
            const model = new ExtraModel();
            set(model, data);
            extras.push(model);
          });
          this.extras = extras;
        }
        this.stateView = StateView.State.content;
      })
      .catch((e) => {
        this.stateView = StateView.State.error;
      });
  };
  changeExtra = (k, v, index) => {
    this.extras[index].changeData(k, v);
  };

  addExtra = (data, index) => {
    this.extras[index].loading = true;
    CartService.addExtra({ extras: [data] }, { code: this.cartId })
      .then((res) => {
        this.extras[index].loading = false;
        if (res.httpStatus == 200) {
          if (res.extra != undefined) {
            this.extras[index].cart.push(res.extra);
          }

          this.extras[index].current_people = 1;
          this.extras[index].current_number_book = 1;
        } else {
          message.error(THelper.t("checkout.error_cannot_add_room"));
        }
        this.silentDataSide();
      })
      .catch((e) => {
        this.extras[index].loading = false;
        message.error(THelper.t("checkout.error_cannot_add_room"));
      });
  };

  extraRemove = (extraIndex, index) => {
    if (this.extras[index].cart[extraIndex] == undefined) {
      return;
    }

    this.extras[index].cart[extraIndex].loading = true;
    const data = { id: this.extras[index].cart[extraIndex].id };
    CartService.removeExtras(data, { code: this.cartId })
      .then((res) => {
        this.extras[index].cart.splice(extraIndex, 1);
        this.silentDataSide();
      })
      .catch((e) => {
        this.extras[index].cart[extraIndex].loading = false;
      });
  };

  getInfo = (data = {}) => {
    this.stateView = StateView.State.loading;
    this.extras = [];
    const res = CartService.getInfo(data, { code: this.cartId })
      .then((res) => {
        this.countries = res.countries;
        this.custom_field = res.fields;
        this.stateView = StateView.State.content;
      })
      .catch((e) => {
        this.stateView = StateView.State.error;
      });
  };

  changePeopleData = (i, key, value) => {
    if (this.cart.peopleData[i] == undefined) {
      return;
    }
    this.cart.peopleData[i][key] = value;
    if (key == "country") {
      const findIndex = this.countries.findIndex((e) => e.value == value);
      if (findIndex >= 0) {
        this.cart.peopleData[i]["cities"] = this.countries[findIndex].cities;
      }
    }
  };

  offerSubmit = (data, router) => {
    this.loading = true;
    data.payment_method = this.paymentMethod;

    CartService.submitDataBooking(data, { code: this.cartId })
      .then((res) => {
        if (res.goto == "payment") {
          router.push(`/checkout/payment?id=${this.cart.id}`);
        } else if (res.goto == "booking") {
          router.push(Routes.bookingView(this.cart.id));
        }
        this.loading = false;
      })
      .catch((e) => {
        this.loading = false;
      });
  };

  getSecretPayStripe = (data) => {
    this.stateViewPayment = StateView.State.content;
  };

  getSecretPay = (data) => {
    this.paymentKey = "";
    this.paymentReference = "";
    this.stateViewPayment = StateView.State.loading;
    data.paymentType = this.paymentType;
    CartService.getSecretPay(data, { code: this.cartId })
      .then((res) => {
        this.paymentKey = res.payment_clientSecret;
        this.paymentId = res.payment_id;
        this.paymentReference = res.reference;
        this.stateViewPayment = StateView.State.content;
      })
      .catch((e) => {
        this.stateViewPayment = StateView.State.error;
      });
  };
  getSecretSofort = (data) => {
    this.paymentKey = "";
    this.paymentReference = "";
    this.stateViewPayment = StateView.State.loading;
    CartService.getPaySofort(data, { code: this.cartId })
      .then((res) => {
        this.paymentKey = res.payment_clientSecret;
        this.paymentId = res.payment_id;
        this.paymentReference = res.reference;
        this.stateViewPayment = StateView.State.content;
      })
      .catch((e) => {
        this.stateViewPayment = StateView.State.error;
      });
  };

  checkPayment = (data = {}) => {
    this.loadingCheckout = true;
    data.reference = this.paymentReference;
    data.paymentType = this.paymentType;
    CartService.getPaymentCheck(data, { code: this.cartId })
      .then((res) => {
        this.loadingCheckout = false;
        if (res.data?.httpStatus == 200 && res.data?.msg === "successfully") {
          router.push(this.successPaymentRedirectURL + this.cart.id);
        } else {
          this.router.push(Routes.bookingView(this.cartId));
        }
      })
      .catch((e) => {
        this.loadingCheckout = false;
      });
  };

  checkInstallmentPayment = (callbackSuccess, callbackFailed) => {
    const body = {
      code: this.cartId,
      reference: this.paymentReference,
    };

    CartService.checkInstallmentPayment(body)
      .then((res) => {
        callbackSuccess();
      })
      .catch((e) => {
        callbackFailed();
      });
  };

  getSecretKlarna = (data) => {
    this.loading = true;
    CartService.getPayKlarna(data, { code: this.cartId })
      .then((res) => {
        this.loading = false;
        if (res.url != null) {
          window.location = res.url;
        }
      })
      .catch((e) => {
        this.loading = false;
      });
  };

  paymentSubmit = (data) => {
    this.loading = true;
    CartService.paymentSubmit(data, { code: this.cartId })
      .then((res) => {
        this.loading = false;
        this.router.push(Routes.bookingView(this.cartId));
      })
      .catch((e) => {
        this.loading = false;
      });
  };

  getPaypalUrl = (data = {}, redirect) => {
    this.loading = true;
    data.paymentType = this.paymentType;
    CartService.getPaypalUrl(data, { code: this.cartId })
      .then((res) => {
        if (res.url != undefined && !redirect) {
          window.location = res.url;
        }
        this.loading = false;
      })
      .catch((e) => {
        this.loading = false;
      });
  };

  couponCheck = (data = {}) => {
    this.loadingCoupon = true;
    this.showVoucherError = false;
    this.voucherError = "";
    this.isCoupanValid = false;
    this.voucher = null;

    CartService.couponCheck(data, { code: this.cartId })
      .then((res) => {
        this.isCoupanValid = true;
        this.loadingCoupon = false;
        this.voucher = data?.code;
        this.silentDataSide();
      })
      .catch((e) => {
        this.voucher = null;
        this.voucherError = e?.response?.data?.error;
        this.showVoucherError = true;
        this.loadingCoupon = false;
        this.isCoupanValid = false;
        message.error(THelper.t("checkout.not_found_coupon"));
      });
  };
}
